import {
  createAsyncThunk, createSlice, PayloadAction
} from '@reduxjs/toolkit'
import { apiFetchUserInfo } from '../../../../api/services/user/user'
import { ApiFetchUserInfoResponse } from '../../../../api/services/user/user.types'
import { State, ThunkErrorObject } from '../../../store.types'
import {
  ApiUserDetailsState,
  GetUserDetailsParams,
  loadedApiUserDetailsState,
  loadingApiUserDetailsState
} from './ApiUserDetailsSlice.types'

const initialState: ApiUserDetailsState = {
  ApiUserDetailsStates: []
}

export const getUserDetails = createAsyncThunk<
ApiFetchUserInfoResponse,
GetUserDetailsParams,
{ rejectValue: ThunkErrorObject }
>('apiUserDetails/getUserDetails', async (state, thunkApi) => {
  const { userId, userToken, windowId } = state
  try {
    const serverPath = (thunkApi.getState() as State).user.serverUrl
    const response = await apiFetchUserInfo(userToken, serverPath, userId)
    const resData = response.data
    if (!resData.ok) {
      return thunkApi.rejectWithValue({
        message: 'errors.an_error_has_ocurred',
        windowId
      })
    }
    return resData
  } catch (error) {
    return thunkApi.rejectWithValue({
      message: 'errors.an_error_has_ocurred',
      windowId
    })
  }
})

export const apiUserDetailsSlice = createSlice({
  name: 'apiUserDetails',
  initialState,
  reducers: {
    removeApiUserDetails: (
      state,
      { payload: { windowId } }: PayloadAction<{ windowId: string }>
    ) => {
      state.ApiUserDetailsStates = state.ApiUserDetailsStates.filter(
        (
          apiUserDetail: loadedApiUserDetailsState | loadingApiUserDetailsState
        ) => apiUserDetail.windowId !== windowId
      )
    },
    changeUserDetails: (
      state,
      { payload }: PayloadAction<{
        windowId: string
        data: Partial<ApiFetchUserInfoResponse>
      }>
    ) => {
      const userDetailsStateToChange = state.ApiUserDetailsStates.find(
        (apiUserDetails) => apiUserDetails.windowId === payload.windowId
      ) as loadedApiUserDetailsState
      if (userDetailsStateToChange) {
        userDetailsStateToChange.data = {
          ...userDetailsStateToChange.data,
          ...payload.data
        }
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(
      getUserDetails.pending,
      (
        state,
        { meta: { arg: { userId, windowId } } }
      ) => {
        const stateToChange = state.ApiUserDetailsStates.find(
          (apiUserDetail) => apiUserDetail.windowId === windowId
        )
        if (stateToChange != null) {
          stateToChange.loading = true
        } else {
          state.ApiUserDetailsStates.push({
            loading: true,
            userId,
            windowId
          })
        }
      }
    )
    builder.addCase(
      getUserDetails.rejected,
      (
        state,
        {
          payload,
          meta: { arg: { windowId } }
        }
      ) => {
        const userDetailStateToFullfilData = state.ApiUserDetailsStates.find(
          (apiUserDetail) => apiUserDetail.windowId === windowId
        )
        if (userDetailStateToFullfilData != null) {
          userDetailStateToFullfilData.loading = false
          userDetailStateToFullfilData.error = payload?.message
        }
      }
    )
    builder.addCase(
      getUserDetails.fulfilled,
      (
        state,
        {
          payload,
          meta: { arg: { windowId } }
        }
      ) => {
        const userDetailStateToFullfilData = state.ApiUserDetailsStates.find(
          (apiUserDetail) => apiUserDetail.windowId === windowId
        )
        if (userDetailStateToFullfilData != null) {
          userDetailStateToFullfilData.loading = false
          userDetailStateToFullfilData.data = payload
        }
      }
    )
  }
})

export const { removeApiUserDetails, changeUserDetails } =
  apiUserDetailsSlice.actions
